import React, { useState } from "react";
import { X } from "lucide-react";

const inp = "bg-black border border-white/10 px-3 py-2 text-sm focus:border-red-600 outline-none";

// Add/remove a list of YYYY-MM-DD dates (public holidays / rescheduled classes).
const weekOf = (d) => { const x = new Date(d + "T12:00:00"); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return [...Array(7)].map((_, i) => { const y = new Date(x); y.setDate(x.getDate() + i); return y.toISOString().slice(0, 10); }); };

export default function DateListInput({ value = [], onChange, label = "Skipped dates", hint, testId = "skip-dates", allowWeek = false }) {
  const [d, setD] = useState("");
  const add = () => { if (d && !value.includes(d)) onChange([...value, d].sort()); setD(""); };
  const addWeek = () => { if (d) onChange([...new Set([...value, ...weekOf(d)])].sort()); setD(""); };
  return (
    <div data-testid={testId}>
      <label className="eyebrow block mb-1">{label}</label>
      <div className="flex gap-2">
        <input type="date" value={d} onChange={e => setD(e.target.value)} className={`${inp} flex-1`} data-testid={`${testId}-input`} />
        <button type="button" onClick={add} className="btn-ghost !py-2 !px-3 !text-xs" data-testid={`${testId}-add`}>Add day</button>
        {allowWeek && <button type="button" onClick={addWeek} title="Skip the whole Mon–Sun week containing this date" className="btn-ghost !py-2 !px-3 !text-xs" data-testid={`${testId}-add-week`}>Add whole week</button>}
      </div>
      {hint && <div className="text-[10px] text-zinc-500 mt-1">{hint}</div>}
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {value.map(x => (
            <span key={x} className="inline-flex items-center gap-1 text-[11px] bg-white/5 border border-white/10 px-2 py-0.5" data-testid={`${testId}-chip-${x}`}>
              {x}<button type="button" onClick={() => onChange(value.filter(v => v !== x))} className="hover:text-red-500"><X size={10} /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
